import { addAlert } from "../../../MsgNotify/msgNotifyActions";
import { httpGet, httpPost, httpPut } from "../../../Util/http";
import { crewRates } from "../../../CustomPricelist/constants";

export const SET_PREV_INVOICE = "tilbud/SET_PREV_INVOICE";
export const setPrevInvoice = (invoiceState, index) => ({
  type: SET_PREV_INVOICE,
  invoiceState: invoiceState,
  index,
});

export const MARK_SAVED = "tilbud/MARK_SAVED";
export const markSaved = () => ({
  type: MARK_SAVED,
});

export const SET_INVOICE_CONTENT = "tilbud/SET_INVOICE_CONTENT";
export const setInvoiceContent = (invoice) => ({
  type: SET_INVOICE_CONTENT,
  crew: invoice.pCalc.crew,
  activities: invoice.pCalc.activities,
  measurements: invoice.pCalc.measurements,
  usage: invoice.pCalc.usage,
  materiels: invoice.materiels,
  dailyreports: invoice.ds,
  employeeHoursCalc: invoice.employeeHoursCalc,
  deliveryNotes: invoice.pCalc.deliverynotes,
});

export const UPDATE_EMPLOYEE_CALC = "tilbud/UPDATE_EMPLOYEE_CALC";
export const updateEmployeeCalc = (calc) => ({
  type: UPDATE_EMPLOYEE_CALC,
  calc,
});
export const UPDATE_OFFERS = "tilbud/UPDATE_OFFERS";
export const updateOffers = (offersId, offers) => ({
  type: UPDATE_OFFERS,
  offersId,
  offers,
});

export const UPDATE_PRODUCT_DISCOUNTS = "tilbud/UPDATE_PRODUCT_DISCOUNTS";
export const updateProductDiscounts = (productDiscounts) => ({
  type: UPDATE_PRODUCT_DISCOUNTS,
  productDiscounts,
});

export const UPDATE_CREW_RATES = "tilbud/UPDATE_CREW_RATES";
export const updateCrewRates = (crewRates) => ({
  type: UPDATE_CREW_RATES,
  crewRates,
});

export const UPDATE_EMPLOYEE_FUNCTION_ROW =
  "tilbud/UPDATE_EMPLOYEE_FUNCTION_ROW";
export const updateEmployeeFunction = (fun, object) => {
  return {
    type: UPDATE_EMPLOYEE_FUNCTION_ROW,
    fun,
    object,
  };
};

export const UPDATE_OTHERS_ROW = "tilbud/UPDATE_OTHERS_ROW";
export const updateOthersRow = (index, other) => ({
  type: UPDATE_OTHERS_ROW,
  index,
  other,
});

export const ADD_OTHER_ROW = "tilbud/ADD_OTHER_ROW";
export const addOthersRow = () => ({
  type: ADD_OTHER_ROW,
  other: {
    0: "",
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: "",
  },
});

export const ADD_DELIVERYNOTES_ROW = "tilbud/ADD_DELIVERYNOTES_ROW";
export const addDeliveryNotesRow = () => ({
  type: ADD_DELIVERYNOTES_ROW,
  deliveryNote: {
    number: "",
    pos: "",
    specification: "",
    supplier: "",
  },
});

export const ADD_MEASUREMENTS_ROW = "tilbud/ADD_MEASUREMENTS_ROW";
export const addMeasurementsRow = () => ({
  type: ADD_MEASUREMENTS_ROW,
  measurement: {
    pos: "",
    type: "",
    amount: 0,
    length: 0,
    depth: 0,
    area: "",
    price: 0,
  },
});

export const ADD_MATERIEL_ROW = "tilbud/ADD_MATERIEL_ROW";
export const addMaterielRow = () => ({
  type: ADD_MATERIEL_ROW,
  materiel: {
    id: Math.random(),
    name: "",
    price: 0,
    type: "Materiel",
    unit: "",
    amount: 0,
  },
});

export const ADD_MATERIEL = "tilbud/ADD_MATERIEL";
export const addMateriel = (materiel) => ({
  type: ADD_MATERIEL,
  materiel,
});

export const ADD_MATERIALE_ROW = "tilbud/ADD_MATERIALE_ROW";
export const addMaterialeRow = () => ({
  type: ADD_MATERIALE_ROW,
  materiel: {
    id: Math.random(),
    name: "",
    price: 0,
    type: "Materiale",
    unit: "",
    amount: 0,
  },
});

export const ADD_ACTIVITY_ROW = "tilbud/ADD_ACTIVITY_ROW";
export const addActivityRow = () => ({
  type: ADD_ACTIVITY_ROW,
  activity: {
    activityGroupName: "h" + Math.random(),
    display: "Diverse",
    pos: "",
    price: 0,
    totalHours: 0,
    subActivities: [],
  },
});

export const UPDATE_OFFER_ROW = "tilbud/UPDATE_OFFER_ROW";
export const updateOfferRow = (index, offer) => ({
  type: UPDATE_OFFER_ROW,
  index,
  offer,
});

export const ADD_OFFER_ROW = "tilbud/ADD_OFFER_ROW";
export const addOfferRow = () => ({
  type: ADD_OFFER_ROW,
  offer: {
    0: "",
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: "",
  },
});

export const UPDATE_ACTIVITY_ROW = "tilbud/UPDATE_ACTIVITY_ROW";
export const updateActivityRow = (index, activity) => ({
  type: UPDATE_ACTIVITY_ROW,
  index,
  activity,
});

export const UPDATE_MATERIEL_ROW = "tilbud/UPDATE_MATERIEL_ROW";
export const updateMateriel = (index, materiel) => ({
  type: UPDATE_MATERIEL_ROW,
  index,
  materiel,
});

export const UPDATE_MEASUREMENT_ROW = "tilbud/UPDATE_MEASUREMENT_ROW";
export const updateMeasurement = (measurement, index) => ({
  type: UPDATE_MEASUREMENT_ROW,
  index,
  measurement,
});
export const UPDATE_DELIVERY_NOTE_ROW = "tilbud/UPDATE_DELIVERY_NOTE_ROW";
export const updateDeliveryNote = (deliveryNote, index) => {
  return {
    type: UPDATE_DELIVERY_NOTE_ROW,
    index,
    deliveryNote,
  };
};

export const UPDATE_DELIVERY_NOTE_BILAG = "tilbud/UPDATE_DELIVERY_NOTE_BILAG";
export const updateBilag = (bilag, index) => {
  return (dispatch, getState) => {
    if (!bilag) {
      dispatch({
        type: UPDATE_DELIVERY_NOTE_BILAG,
        index,
        bilag,
      });
    } else {
      let session = getState().TilbudReducer.sessionIdForFile;

      var _url = process.env.REACT_APP_webApiEndPoint + "/api/tilbud/bilag";
      httpPost(_url, {
        content: bilag.file.split(",")[1],
        fileName: encodeURIComponent(bilag.name),
        session: session,
      })
        .then((resp) => resp.json())
        .then((resp) => {
          bilag.url = resp.url;
          dispatch({
            type: UPDATE_DELIVERY_NOTE_BILAG,
            index,
            bilag,
          });
          dispatch(setSessionIdForFileUpload(resp.session));
        })
        .catch((e) => {
          alert("Kunne ikke upload fil, prøv igen");
        });
    }
  };
};

export const UPDATE_SELECTED_IMAGES = "tilbud/UPDATE_SELECTED_IMAGES";
export const updateSelectedImages = (images) => ({
  type: UPDATE_SELECTED_IMAGES,
  images,
});

export const UPDATE_USAGE = "tilbud/UPDATE_USAGE";
export const updateUsage = (usage) => ({
  type: UPDATE_USAGE,
  usage,
});

export const SET_SESSION_ID_FOR_FILE = "tilbud/SET_SESSION_ID_FOR_FILE";
export const setSessionIdForFileUpload = (id) => ({
  type: SET_SESSION_ID_FOR_FILE,
  id,
});

export const UPDATE_INVOICE_ROW = "tilbud/UPDATE_INVOICE_ROW";
export const updateInvoice = (invoice, index) => {
  return {
    type: UPDATE_INVOICE_ROW,
    index,
    invoice,
  };
};

export const ADD_INVOICE_ROW = "tilbud/ADD_INVOICE_ROW";
export const addInvoiceRow = () => {
  return (dispatch, getState) => {
    let len = 1;
    let invoices = getState().TilbudReducer.invoices;
    if (invoices) {
      len = invoices.length + 1;
    }
    dispatch({
      type: ADD_INVOICE_ROW,
      invoice: {
        pos: "16." + len,
        name: "",
        price: "",
      },
    });
  };
};

export const UPDATE_WORKPLACE_DAILYREPORT_STATS =
  "tilbud/UPDATE_WORKPLACE_DAILYREPORT_STATS";
export const updateWorkplaceDailyreportStats = (stats) => ({
  type: UPDATE_WORKPLACE_DAILYREPORT_STATS,
  stats,
});

export const SELECT_PRICELIST_ACTION = "tilbud/SELECT_PRICELIST_ACTION";
export const selectPriceListAction = (id) => ({
  type: SELECT_PRICELIST_ACTION,
  id,
});

export const MARK_DELETED = "tilbud/MARK_DELETED";
export const markDeleted = (status) => ({
  type: MARK_DELETED,
  status,
});

export const UPDATE_BLACKLISTED_DAILYREPORTS =
  "tilbud/UPDATE_BLACKLISTED_DAILYREPORTS";
export const updateBlacklistedDailyreports = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_BLACKLISTED_DAILYREPORTS,
      list,
    });
    let dailyreports = getState().TilbudReducer.dailyreports;
    let blacklisted = getState().TilbudReducer.blacklistedDailyreports;
    let materiels = getState().TilbudReducer.materiels;

    let invoice = {
      ds: dailyreports,
      materiels: materiels,
      pCalc: {
        deliverynotes: [],
      },
    };
    let activities = [];
    let measurements = [];
    let employeeRegs = [];
    let usage = [];
    let deliveryNotes = [];

    dailyreports.forEach((d) => {
      if (blacklisted[d.aggregateId]) {
        //
      } else {
        if (d.checkInCheckOutMode) {
          activities.push(
            ...JSON.parse(JSON.stringify(d.activityRegistrations))
          );
          measurements.push(
            ...JSON.parse(JSON.stringify(d.measurementRegistrations))
          );
          employeeRegs.push(
            ...JSON.parse(JSON.stringify(d.employeeRegistrations))
          );
          usage.push(...JSON.parse(JSON.stringify(d.materielRegistrations)));
          deliveryNotes.push(...JSON.parse(JSON.stringify(d.deliveryNotes)));
        }
      }
    });

    invoice.pCalc.deliverynotes = calcDeliveryNotes(deliveryNotes);
    invoice.employeeHoursCalc = calcEmployeeHours(
      employeeRegs,
      getState().TilbudReducer.crewRates
    );
    invoice.pCalc.activities = calcActivity(activities);
    invoice.pCalc.measurements = calcMeasurements(measurements);
    invoice.pCalc.usage = calcUsage(usage);

    if (!isEmpty(getState().TilbudReducer.productDiscounts)) {
      let usageWithStdPrice = setUsageInitDis(
        invoice.pCalc.usage,
        materiels,
        getState().TilbudReducer.productDiscounts
      );
      invoice.pCalc.usage = usageWithStdPrice;
    } else {
      let usageWithStdPrice = setUsageInit(invoice.pCalc.usage, materiels);
      invoice.pCalc.usage = usageWithStdPrice;
    }

    dispatch(setInvoiceContent(invoice));
  };
};

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

function isNormal(check, marker1, marker2) {
  return marker1 < check && check <= marker2;
}

function isOvertime(check, marker2, marker3) {
  return marker2 < check && check <= marker3;
}

function intersecter(checkin, checkout, mark1, mark2) {
  if (checkin == checkout) {
    return 0;
  }
  if (mark1 > mark2) {
    let num = 0;
    num += intersecter(checkin, checkout, mark1, 2400);
    num += intersecter(checkin, checkout, 0, mark2);
    return num;
  }

  if (checkout < checkin) {
    let num = 0;
    // first
    num += intersecter(checkin, 2400, mark1, mark2);
    // second
    num += intersecter(0, checkout, mark1, mark2);
    return num;
  }

  if (checkout < mark2 && checkout > mark1) {
    if (mark1 < checkin) {
      return checkout - checkin;
    }
    return checkout - mark1;
  }
  if (checkin >= mark1 && checkin < mark2) {
    return mark2 - checkin;
  }
  if (checkin < mark1 && checkin < mark2) {
    if (checkout < mark2) {
      let r = checkout - mark1;
      if (r < 0) {
        return 0;
      } else {
        return r;
      }
    }
    return mark2 - mark1;
  }
  return 0;
}

function workingHoursBetweenDates(
  checkIn,
  checkOut,
  markerTime1,
  markerTime2,
  markerTime3,
  isWeekend
) {
  let normal = 0,
    overtime = 0,
    night = 0,
    weekend = 0;
  if (checkIn === null || checkOut === null) {
    return { normal, overtime, night, weekend };
  }
  const q = { 15: 25, 30: 50, 45: 75, "0": "00" };
  let time1 = checkIn.split(":");
  let time2 = checkOut.split(":");
  let marker1 = markerTime1.split(":");
  let marker2 = markerTime2.split(":");
  let marker3 = markerTime3.split(":");

  let checkInHours = parseInt(time1[0], 10);
  let checkInMins = parseInt(time1[1], 10);
  let checkOutHours = parseInt(time2[0], 10);
  let checkOutMins = parseInt(time2[1], 10);

  let marker1Hours = parseInt(marker1[0], 10);
  let marker1Mins = parseInt(marker1[1], 10);

  let marker2Hours = parseInt(marker2[0], 10);
  let marker2Mins = parseInt(marker2[1], 10);

  let marker3Hours = parseInt(marker3[0], 10);
  let marker3Mins = parseInt(marker3[1], 10);

  let checkin = parseInt(checkInHours + "" + q[checkInMins.toString()]);
  let checkout = parseInt(checkOutHours + "" + q[checkOutMins.toString()]);
  let mark1 = parseInt(marker1Hours + "" + q[marker1Mins.toString()]);
  let mark2 = parseInt(marker2Hours + "" + q[marker2Mins.toString()]);
  let mark3 = parseInt(marker3Hours + "" + q[marker3Mins.toString()]);
  if (isWeekend === true) {
    weekend = intersecter(checkin, checkout, "0", "2400");
  } else {
    normal = intersecter(checkin, checkout, mark1, mark2);
    overtime = intersecter(checkin, checkout, mark2, mark3);
    night = intersecter(checkin, checkout, mark3, mark1);
  }

  return {
    normal: normal / 100,
    overtime: overtime / 100,
    night: night / 100,
    weekend: weekend / 100,
  };
}

function calcEmployeeHours(employeeRegistrations, calcsForMarkers) {
  let calcs = {};
  let breaks = 0;

  employeeRegistrations.map((regs) => {
    breaks += regs.break;
    let goToNextRegistration = false;
    regs.timeRegistrations.map((time, index) => {
      if (calcs[time.employeeFunction]) {
        let markers = calcs[time.employeeFunction].markers;
        let hours = workingHoursBetweenDates(
          time.checkIn,
          time.checkOut,
          markers[0],
          markers[1],
          markers[2],
          regs.weekend
        );
        if (index === 0 || goToNextRegistration) {
          if (hours.normal >= regs.break) {
            hours.normal = hours.normal - regs.break;
            if (goToNextRegistration) {
              goToNextRegistration = false;
            }
          } else if (hours.overtime >= regs.break) {
            hours.overtime = hours.overtime - regs.break;
            if (goToNextRegistration) {
              goToNextRegistration = false;
            }
          } else if (hours.night >= regs.break) {
            hours.night = hours.night - regs.break;
            if (goToNextRegistration) {
              goToNextRegistration = false;
            }
          } else if (hours.weekend >= regs.break) {
            hours.weekend = hours.weekend - regs.break;
            if (goToNextRegistration) {
              goToNextRegistration = false;
            }
          } else {
            goToNextRegistration = true;
          }
        }
        let total =
          parseFloat(hours.normal) +
          parseFloat(hours.overtime) +
          parseFloat(hours.night) +
          parseFloat(hours.weekend);

        calcs[time.employeeFunction].pool += total;
        calcs[time.employeeFunction].details[0].hours += hours.normal;
        calcs[time.employeeFunction].details[1].hours += hours.overtime;
        calcs[time.employeeFunction].details[2].hours += hours.night;
        calcs[time.employeeFunction].details[3].hours += hours.weekend;

        let normalPrice =
          calcs[time.employeeFunction].details[0].price *
          calcs[time.employeeFunction].details[0].hours;

        let overtimePrice =
          calcs[time.employeeFunction].details[1].price *
          calcs[time.employeeFunction].details[1].hours;

        let nightPrice =
          calcs[time.employeeFunction].details[2].price *
          calcs[time.employeeFunction].details[2].hours;

        let weekendPrice =
          calcs[time.employeeFunction].details[3].price *
          calcs[time.employeeFunction].details[3].hours;

        calcs[time.employeeFunction].sum = parseFloat(
          normalPrice + overtimePrice + nightPrice + weekendPrice
        )
          .toFixed(2)
          .toString()
          .replace(".00", "")
          .replace(".", ",");
      } else {
        let defaultMarkers = ["06:00", "16:00", "22:00"];
        let markers = calcsForMarkers[time.employeeFunction]
          ? calcsForMarkers[time.employeeFunction].markers
            ? calcsForMarkers[time.employeeFunction].markers
            : defaultMarkers
          : defaultMarkers;
        let hours = workingHoursBetweenDates(
          time.checkIn,
          time.checkOut,
          markers[0],
          markers[1],
          markers[2],
          regs.weekend
        );
        if (index === 0 || goToNextRegistration) {
          if (hours.normal >= regs.break) {
            hours.normal = hours.normal - regs.break;
            if (goToNextRegistration) {
              goToNextRegistration = false;
            }
          } else if (hours.overtime >= regs.break) {
            hours.overtime = hours.overtime - regs.break;
            if (goToNextRegistration) {
              goToNextRegistration = false;
            }
          } else if (hours.night >= regs.break) {
            hours.night = hours.night - regs.break;
            if (goToNextRegistration) {
              goToNextRegistration = false;
            }
          } else if (hours.weekend >= regs.break) {
            hours.weekend = hours.weekend - regs.break;
            if (goToNextRegistration) {
              goToNextRegistration = false;
            }
          } else {
            goToNextRegistration = true;
          }
        }
        let total =
          parseFloat(hours.normal) +
          parseFloat(hours.overtime) +
          parseFloat(hours.night) +
          parseFloat(hours.weekend);
        let weekendDescription = "Lørdag, Søndag og helligdag";
        let weekendPrice = 500;
        try {
          weekendDescription = calcsForMarkers[time.employeeFunction]
            ? calcsForMarkers[time.employeeFunction].details[3].description
            : weekendDescription;
          weekendPrice = calcsForMarkers[time.employeeFunction]
            ? calcsForMarkers[time.employeeFunction].details[3].price
            : weekendPrice;
        } catch (e) {
          // silent
        }

        calcs[time.employeeFunction] = {
          pos: "10." + (Object.keys(calcs).length + 1),
          pool: total,
          function: time.employeeFunction,
          functionDisplay: calcsForMarkers[time.employeeFunction]
            ? calcsForMarkers[time.employeeFunction].functionDisplay
            : time.employeeFunction,
          price: "",
          sum: total * 500,
          markers: markers,
          unfolded: calcsForMarkers[time.employeeFunction]
            ? calcsForMarkers[time.employeeFunction].unfolded
              ? true
              : false
            : false,
          details: [
            {
              pos: "10." + (Object.keys(calcs).length + 1) + ".1",
              descriptionKey: time.employeeFunction + " normal",
              description: calcsForMarkers[time.employeeFunction]
                ? calcsForMarkers[time.employeeFunction].details[0].description
                : "Normal",
              hours: hours.normal,
              price: calcsForMarkers[time.employeeFunction]
                ? calcsForMarkers[time.employeeFunction].details[0].price
                : 500,
            },
            {
              pos: "10." + (Object.keys(calcs).length + 1) + ".2",
              descriptionKey: time.employeeFunction + " overtid",
              description: calcsForMarkers[time.employeeFunction]
                ? calcsForMarkers[time.employeeFunction].details[1].description
                : "Overtid",
              hours: hours.overtime,
              price: calcsForMarkers[time.employeeFunction]
                ? calcsForMarkers[time.employeeFunction].details[1].price
                : 500,
            },
            {
              pos: "10." + (Object.keys(calcs).length + 1) + ".3",
              descriptionKey: time.employeeFunction + " nat",
              description: calcsForMarkers[time.employeeFunction]
                ? calcsForMarkers[time.employeeFunction].details[2].description
                : "Nat",
              hours: hours.night,
              price: calcsForMarkers[time.employeeFunction]
                ? calcsForMarkers[time.employeeFunction].details[2].price
                : 500,
            },
            {
              pos: "10." + (Object.keys(calcs).length + 1) + ".4",
              descriptionKey: time.employeeFunction + " weekend",
              description: weekendDescription,
              hours: hours.weekend,
              price: weekendPrice,
            },
          ],
        };
        let normalPrice2 =
          calcs[time.employeeFunction].details[0].price *
          calcs[time.employeeFunction].details[0].hours;

        let overtimePrice2 =
          calcs[time.employeeFunction].details[1].price *
          calcs[time.employeeFunction].details[1].hours;

        let nightPrice2 =
          calcs[time.employeeFunction].details[2].price *
          calcs[time.employeeFunction].details[2].hours;

        let weekendPrice2 =
          calcs[time.employeeFunction].details[3].price *
          calcs[time.employeeFunction].details[3].hours;

        calcs[time.employeeFunction].sum = parseFloat(
          normalPrice2 + overtimePrice2 + nightPrice2 + weekendPrice2
        )
          .toFixed(2)
          .toString()
          .replace(".00", "")
          .replace(".", ",");
      }
    });
  });

  // if (!isEmpty(calcs)) {
  //     calcs['pause'] = {
  //         pos: '10.' + (Object.keys(calcs).length + 1),
  //         functionDisplay: calcsForMarkers["pause"] ? calcsForMarkers["pause"].functionDisplay : 'Pausetimer afholdt',
  //         function: 'pause',
  //         pool: breaks,
  //         price: calcsForMarkers["pause"] ? calcsForMarkers["pause"].price : -500,
  //         sum: calcsForMarkers["pause"] ? parseFloat(calcsForMarkers["pause"].price) * breaks : breaks * -500,
  //         details: []
  //     }
  // }
  return {
    calcs,
    breaks,
  };
}

export const recalcEmployee = () => {
  return (dispatch, getState) => {
    let calcs = getState().TilbudReducer.employeeHoursCalc;
    let dailyreports = getState().TilbudReducer.dailyreports;
    let employeeRegs = [];
    dailyreports.map((d) => {
      if (d.checkInCheckOutMode) {
        if (
          new Date(d.date).getDay() === 6 ||
          new Date(d.date).getDay() === 0
        ) {
          d.employeeRegistrations.forEach((obj) => {
            obj.weekend = true;
          });
        }
        employeeRegs.push(...d.employeeRegistrations);
      }
    });
    let newCalcs = calcEmployeeHours(employeeRegs, calcs.calcs);

    dispatch(updateEmployeeCalc(newCalcs));
  };
};

export const recalcEmployeeForCrewRates = (crewRates) => {
  return (dispatch, getState) => {
    let dailyreports = getState().TilbudReducer.dailyreports;
    let employeeRegs = [];
    dailyreports.map((d) => {
      if (d.checkInCheckOutMode) {
        if (
          new Date(d.date).getDay() === 6 ||
          new Date(d.date).getDay() === 0
        ) {
          d.employeeRegistrations.forEach((obj) => {
            obj.weekend = true;
          });
        }
        employeeRegs.push(...d.employeeRegistrations);
      }
    });
    let newCalcs = calcEmployeeHours(employeeRegs, crewRates);

    dispatch(updateEmployeeCalc(newCalcs));
  };
};

function setUsageInit(usage, materiels) {
  let materielCount = 0;
  let materialCount = 0;
  return usage.map((m, index) => {
    if (materiels[m.id].type === "Materiel") {
      materielCount += 1;
      m.pos = "12." + materielCount;
    } else {
      materialCount += 1;
      m.pos = "13." + materialCount;
    }
    m.price = materiels[m.id].price;
    m.name = materiels[m.id].name;
    m.unit = materiels[m.id].unit;
    m.type = materiels[m.id].type;

    return m;
  });
}

function setUsageInitDis(usage, materiels, dis) {
  let materielCount = 0;
  let materialCount = 0;
  return usage.map((m, index) => {
    if (materiels[m.id].type === "Materiel") {
      materielCount += 1;
      m.pos = "12." + materielCount;
    } else {
      materialCount += 1;
      m.pos = "13." + materialCount;
    }
    if (dis[m.id]) {
      m.price = dis[m.id].discount;
    } else {
      m.price = materiels[m.id].price;
    }
    m.name = materiels[m.id].name;
    m.unit = materiels[m.id].unit;
    m.type = materiels[m.id].type;
    return m;
  });
}

function getPcalcRequest(start, end, workplaceId) {
  var _url =
    process.env.REACT_APP_webApiEndPoint +
    `api/dailyreports/${workplaceId}/pcalc2?dateFrom=${start}&dateTo=${end}&showNotInvoicedOnly=false`;
  return httpGet(_url).then((invoice) => invoice.json());
}

function getOffersRequest(id) {
  const url = process.env.REACT_APP_productCatalogEndPoint + `api/offers/${id}`;
  return httpGet(url)
    .then((rsp) => rsp.json())
    .then((f) => {
      return f.map((r) => {
        let obj = r.reduce(function (acc, cur, i) {
          acc[i] = cur;
          return acc;
        }, {});
        return obj;
      });
    });
}

function getProductDiscountsRequest(id) {
  const url =
    process.env.REACT_APP_productCatalogEndPoint + `api/productdiscounts/${id}`;
  return httpGet(url).then((rsp) => rsp.json());
}

function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

export const getWorkplaceDailyreportStats = (id) => {
  return (dispatch, getState) => {
    const url =
      process.env.REACT_APP_webApiEndPoint +
      `/api/dailyreports/${id}?skip=0&take=999999`;
    return httpGet(url)
      .then((rsp) => rsp.json())
      .then((content) => dispatch(updateWorkplaceDailyreportStats(content)));
  };
};

export const getPrevInvoices = (id) => {
  var _url =
    process.env.REACT_APP_webApiEndPoint +
    "/api/tilbud/bilag?workplaceId=" +
    id;
  return httpGet(_url).then((rsp) => rsp.json());
};

export const getOffers = (offerId) => (dispatch, getState) => {
  getOffersRequest(offerId).then((offers) =>
    dispatch(updateOffers(offerId, offers))
  );
};

export const printInvoice = (workplaceId, html) => {
  return (dispatch, getState) => {
    // var _url = process.env.REACT_APP_webApiEndPoint +
    let state = getState().TilbudReducer;
    state.saved = true;
    var _url = process.env.REACT_APP_webApiEndPoint + "/api/tilbud/save";
    return httpPost(_url, {
      workplaceId: workplaceId,
      html: html,
      reduxState: JSON.stringify(state),
    })
      .then((resp) => resp.json())
      .then((json) => dispatch(markSaved()));
  };
};

export const saveChanges = (workplaceId) => {
  return (dispatch, getState) => {
    let state = getState().TilbudReducer;
    state.saved = true;
    var _url = process.env.REACT_APP_webApiEndPoint + "/api/tilbud/save";
    return httpPut(_url, {
      workplaceId: workplaceId,
      id: state.invoiceId,
      html: null,
      reduxState: JSON.stringify(state),
    })
      .then((json) => dispatch(markSaved()))
      .catch((e) => {
        dispatch(addAlert("Kunne ikke opdatere faktura"));
      });
  };
};

function selectDailyreportsHelper(dispatch, stats, id, callback) {
  if (stats) {
    const dailyreports = stats.dailyreports;
    if (!dailyreports) {
      return;
    }
    if (dailyreports.length < 1) {
      dispatch(addAlert("Der er ingen dagrapporter i dette arbejdssted"));
    } else {
      let startDate = "";
      let endDate = "";
      let count = 0;

      dailyreports.forEach((d) => {
        const dDate = new Date(d.date);
        if (callback(d)) {
          if (count === 0) {
            startDate = dDate;
            endDate = dDate;
            count++;
          }
          if (startDate > dDate) {
            startDate = dDate;
          }
          if (endDate < dDate) {
            endDate = dDate;
          }
        }
      });
      dispatch(
        getPCalcAndDailyreports(
          JSON.parse(JSON.stringify(startDate)),
          JSON.parse(JSON.stringify(endDate)),
          id
        )
      );
    }
  }
}

export const selectAllDailyreportsPeriod = (id) => {
  return (dispatch, getState) => {
    const stats = getState().TilbudReducer.stats;
    selectDailyreportsHelper(dispatch, stats, id, () => true);
  };
};

export const selectNonInvoicedDailyreportsPeriod = (id) => {
  return (dispatch, getState) => {
    const stats = getState().TilbudReducer.stats;
    selectDailyreportsHelper(dispatch, stats, id, (d) => !d.invoiced);
  };
};

export const selectApprovedDailyreportsPeriod = (id) => {
  return (dispatch, getState) => {
    const stats = getState().TilbudReducer.stats;
    selectDailyreportsHelper(dispatch, stats, id, (d) => d.approved);
  };
};

function calcMeasurements(measurements) {
  return measurements.map((measurement, index) => {
    measurement.pos = "14." + (index + 1);
    return measurement;
  });
}

function calcDeliveryNotes(deliveryNotes) {
  return deliveryNotes.map((note, index) => {
    note.pos = "15." + (index + 1);
    return note;
  });
}

function calcActivity(activities) {
  let acs = [];
  let ag = groupBy(activities, "activity");
  Object.keys(ag)
    .map((key) => ag[key])
    .forEach((a, index) => {
      let aa = {};
      aa.totalHours = 0;
      aa.price = 0;
      aa.pos = "11." + (index + 1);
      let acg = groupBy(a, "name");
      Object.keys(acg)
        .map((key) => acg[key])
        .map((ac, index) => {
          let subby = {
            name: "",
            hours: 0,
            pos: aa.pos + "." + (index + 1),
          };
          ac.forEach((s) => {
            aa.activityGroupName = s.activity;
            aa.display = s.activity;
            aa.totalHours += s.hours;
            subby.hours += s.hours;
            subby.name = s.name;
          });
          aa.subActivities = aa.subActivities ? aa.subActivities : [];
          aa.subActivities.push(subby);
        });
      acs.push(aa);
    });
  return acs;
}

function calcUsage(usage) {
  let calcs = usage.reduce(function (rv, x) {
    if (rv[x.id]) {
      rv[x.id].amount += x.amount;
    } else {
      rv[x.id] = {
        id: x.id,
        amount: x.amount,
      };
    }
    return rv;
  }, {});

  return Object.keys(calcs).map((key) => calcs[key]);
}

export const getPCalcAndDailyreports = (start, end, workplaceId) => (
  dispatch,
  getState
) => {
  dispatch({ type: "tilbud/SET_INVOICE_DATEPICKER", start, end });
};

export const selectPriceList = (id) => (dispatch, getState) => {
  dispatch(selectPriceListAction(id));
  let usage = getState().TilbudReducer.usage;
  let materiels = getState().TilbudReducer.materiels;
  if (id === "default") {
    dispatch(updateOffers(id, []));
    dispatch(updateProductDiscounts([]));
    let newUsage = usage.map((u) => {
      if (materiels[u.id]) {
        u.price = materiels[u.id].price;
      }
      return u;
    });
    dispatch(updateUsage(newUsage));
    dispatch(updateCrewRates(crewRates));

    let keys = getState().TilbudReducer.employeeHoursCalc.calcs;
    Object.keys(keys).map((k) => {
      let sum = 0;
      keys[k].details.map((d, i) => {
        d.price = crewRates[k].details[i].price;
        sum += parseFloat(d.price) * parseFloat(d.hours);
      });

      keys[k].sum = sum;
    });
    dispatch(updateEmployeeCalc({ calcs: keys }));
  } else {
    dispatch(getOffers(id));
    getProductDiscountsRequest(id)
      .then((f) => {
        return f.reduce(function (acc, cur, i) {
          acc[cur.productId] = cur;
          return acc;
        }, {});
      })
      .then((discounts) => {
        dispatch(updateProductDiscounts(discounts));
        return discounts;
      })
      .then((discounts) => {
        let newUsage = usage.map((u) => {
          if (discounts[u.id]) {
            u.price = discounts[u.id].discount;
          } else {
            u.price = materiels[u.id].price;
          }
          return u;
        });
        dispatch(updateUsage(newUsage));
      });

    httpGet(
      process.env.REACT_APP_productCatalogEndPoint + `api/crewrates?id=${id}`
    )
      .then((res) => res.json())
      .then((data) => JSON.parse(data))
      .then((data) => {
        dispatch(updateCrewRates(data));
        let keys = getState().TilbudReducer.employeeHoursCalc.calcs;
        Object.keys(keys).map((k) => {
          let sum = 0;
          keys[k].details.map((d, i) => {
            d.price = data[k].details[i].price;
            sum += parseFloat(d.price) * parseFloat(d.hours);
          });

          keys[k].sum = sum;
        });
        dispatch(updateEmployeeCalc({ calcs: keys }));
      })
      .catch(() => {
        //doesnt exists
        let c = JSON.parse(JSON.stringify(crewRates));
        dispatch(updateCrewRates(c));
        dispatch(updateEmployeeCalc({ calcs: c }));
      });
  }
};

export const ADD_HEADINGSUBTEXT_EXTRA_INFO =
  "tilbud/ADD_HEADINGSUBTEXT_EXTRA_INFO";
export function addHeadingSubtext_ExtraInfo() {
  return {
    type: ADD_HEADINGSUBTEXT_EXTRA_INFO,
    headingSubtextObj: { heading: "", subtext: "", editMode: true },
  };
}

export const UPDATE_HEADING_EXTRA_INFO = "tilbud/UPDATE_HEADING_EXTRA_INFO";
export function updateHeading_ExtraInfo(text, index) {
  return {
    type: UPDATE_HEADING_EXTRA_INFO,
    index,
    text,
  };
}

export const UPDATE_SUBTEXT_EXTRA_INFO = "tilbud/UPDATE_SUBTEXT_EXTRA_INFO";
export function updateSubtext_ExtraInfo(text, index) {
  return {
    type: UPDATE_SUBTEXT_EXTRA_INFO,
    index,
    text,
  };
}
export const ADD_HEADINGSUBTEXT_CEAS = "tilbud/ADD_HEADINGSUBTEXT_CEAS";
export function addHeadingSubtext_ceas() {
  return {
    type: ADD_HEADINGSUBTEXT_CEAS,
    headingSubtextObj: { heading: "", subtext: "", editMode: true },
  };
}

export const UPDATE_HEADING_CEAS = "tilbud/UPDATE_HEADING_CEAS";
export function updateHeading_ceas(text, index) {
  return {
    type: UPDATE_HEADING_CEAS,
    index,
    text,
  };
}

export const UPDATE_SUBTEXT_CEAS = "tilbud/UPDATE_SUBTEXT_CEAS";
export function updateSubtext_ceas(text, index) {
  return {
    type: UPDATE_SUBTEXT_CEAS,
    index,
    text,
  };
}

export function zipDatasheets() {
  return (dispatch, getState) => {
    var _url =
      process.env.REACT_APP_webApiEndPoint + "/api/invoice/zipdatasheets";
    let materiels = getState().TilbudReducer.materiels;

    let ds = [];
    Object.keys(materiels).forEach((k) => {
      let m = materiels[k];
      if (m.type === "Materiale") {
        let push = false;
        let o = {
          name: m.name,
        };
        if (m.dataSheetUrl) {
          o.datasheetUrl = m.dataSheetUrl;
          push = true;
        }
        if (m.technicalDataSheetUrl) {
          o.technicalDatasheetUrl = m.technicalDataSheetUrl;
          push = true;
        }
        if (m.chemDataSheetUrl) {
          o.chemDatasheetUrl = m.chemDataSheetUrl;
          push = true;
        }

        if (m.dataSheet) {
          o.datasheetUrl = m.dataSheet;
          push = true;
        }

        if (m.technicalDataSheet) {
          o.technicalDatasheetUrl = m.technicalDataSheet;
          push = true;
        }
        if (m.chemDataSheet) {
          o.chemDatasheetUrl = m.chemDataSheet;
          push = true;
        }
        if (push) {
          ds.push(o);
        }
      }
    });

    return httpPost(_url, {
      ds,
    })
      .then((data) => data.blob())
      .then((data) => {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = "datablade.zip";
        link.click();
      });
  };
}

export function zipIt() {
  return (dispatch, getState) => {
    var _url = process.env.REACT_APP_webApiEndPoint + "api/invoice/zipit";
    let s = getState().TilbudReducer.selectedImages;
    let inv = getState().TilbudReducer.invoices;

    let images = Object.keys(s).map((key) => {
      return s[key].original
    });

    let invoices = [];
    inv.forEach((i) => {
      if (!i.bilag) {
      } else {
        invoices.push({
          filename: i.bilag.name,
          url: i.bilag.url,
        });
      }
    });
    return httpPost(_url, {
      images,
      invoices,
    })
      .then((data) => data.blob())
      .then((data) => {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = "faktura_bilag_billeder.zip";
        link.click();
      });
  };
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/actions.js